/**
 * UPS quotes `priceInfo` in major units, while both the design system card and the dataLayer
 * payload work in minor ones.
 *
 * The rounding is load-bearing rather than defensive: `19.99 * 100` is `1998.9999999999998` in
 * IEEE 754, which would put a penny-wrong price on the card and in tracking.
 */
export const toMinorUnits = (majorUnits: number) => Math.round(majorUnits * 100);
